import { useEffect, useRef, useState } from "react";
import { createRequestsSocket } from "../lib/socket";
import { useAuth } from "../state/auth.jsx";

export function useMessagesSocket() {
    const { accessToken, tabActiveHotelId } = useAuth();
    const [latestMessage, setLatestMessage] = useState(null);
    const socketRef = useRef(null);

    useEffect(() => {
        if (!accessToken || !tabActiveHotelId) return;

        // Reuse the existing socket creation logic, passing the explicit hotelId
        const socket = createRequestsSocket(accessToken, tabActiveHotelId);
        socketRef.current = socket;

        socket.on("connect", () => {
            console.log("Messages socket connected");
        });

        socket.on("message.created", (payload) => {
            console.log("New message received:", payload);
            setLatestMessage(payload);
        });

        socket.on("error", (err) => {
            console.error("Socket error:", err);
        });

        socket.connect();

        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
                socketRef.current = null;
            }
        };
    }, [accessToken, tabActiveHotelId]);

    return { latestMessage, socket: socketRef.current };
}

